import { t } from "@/locales";
import type { MenuRoute } from "@/shared/types/route";
import type { RouteRecordRaw } from "vue-router";

const layoutComponent = () => import("@/widgets/app-shell/AppShell.vue");

export const homepageRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Root",
    component: layoutComponent,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/dashboard/DashboardPage.vue"),
        meta: { title: "工作台", localizedTitle: { "zh-CN": "工作台", "zh-TW": "工作臺" } },
      },
    ],
  },
];

export const homepageMenuRoutes: MenuRoute[] = [
  {
    path: "/dashboard",
    name: "Dashboard",
    get title() {
      return t("shell.home");
    },
    icon: "dashboard",
  },
];
